import _ from 'underscore';
import preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import {PaginationView} from '@bingads-webui-component-legacy/github/modules/pagination-control/module/pagination-control';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/bingadsgrid');

const patchTemplate = (template, defaults) => (options) => template(_.defaults(options, defaults));

export default (definePlugin) =>  definePlugin('pagination', ['config', 'gridView', 'projection'], (config, gridView, projection) => {
  const paginationConfig = {
    el: config.pluginsConfig.pagination.container,
    template: patchTemplate(config.pluginsConfig.pagination.template, {
      pageNumberLabelText: i18n.get('Grid_Page_Colon'),
    }),
    pageSize: config.pageable && config.pageable.pageSize,
    availablePageSizes: config.pageable && config.pageable.availablePageSizes,
    pageSizeText: i18n.get('Grid_ShowRows'),
    totalPageCountText: i18n.get('Grid_PageOf'),
    pageNumber: 0,
    previousPageText: i18n.get('Component_Pagination_PreviousPage'),
    nextPageText: i18n.get('Component_Pagination_NextPage'),
    enableRandomPage: config.pluginsConfig.pagination.enableRandomPage,
  };

  const pager = new PaginationView(paginationConfig);

  gridView.on('change:data', (model) => {
    // merge page info between pager and projection;
    pager.itemCount = model.get('count');
    pager.pageSize = projection.get('page.size');
    pager.pageNumber = projection.get('page.number');
    if (model.get('count') > 0) {
      pager.$el.show();
    } else {
      pager.$el.hide();
    }
  });

  pager.on('change:page-number', (pageNumber) => {
    projection.set('page.number', pageNumber);
  });

  pager.on('change:page-size', (pageSize) => {
    projection.set('page.size', pageSize);

    preferencesService.setAtUserLevel({ Name: 'WebApp.CampaignUI.grid', Data: { rowsPerPage: pageSize } });
  });

  return pager;
});
